import { type SyntheticEvent, useState } from 'react';

export type MenuHook<T extends HTMLElement = HTMLElement> = {
  open: boolean;
  menuRef: null | T;
  openMenu: (event?: SyntheticEvent<T>, target?: T | null) => void;
  closeMenu: () => void;
};

export function useMenu<T extends HTMLElement = HTMLElement>(): MenuHook<T> {
  const [menuRef, setMenuRef] = useState<null | T>(null);

  function openMenu(event?: SyntheticEvent<T>, target?: T | null): void {
    setMenuRef(event?.currentTarget ?? target ?? null);
  }

  function closeMenu(): void {
    setMenuRef(null);
  }

  return { open: Boolean(menuRef), menuRef, openMenu, closeMenu };
}

export default useMenu;
